var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Informational Videos',
      "subTitleText": 'Project Spectrum\'s informational videos provide a brief overview of key cybersecurity topics, allowing viewers to gain valuable knowledge in under 10 minutes per video.<br><br>Use this page as a valuable resource to learn all things about cyber security and awareness.'
    }
  })], 1)], 1), _c('div', {
    staticClass: "container-fluid px-xs-1 px-md-5 px-lg-5 px-xl-5"
  }, [_c('section', {
    staticClass: "mt-5",
    attrs: {
      "id": "videos-display-section"
    }
  }, [_c('div', {
    staticClass: "container-fluid px-3 px-md-0 px-lg-0 px-xl-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-start w-100"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-center section-title w-100"
  }, [_c('span', [_vm._v("WATCH VIDEOS")])]), _c('SearchControlWidget', {
    attrs: {
      "inputTextPlaceholder": 'Enter video title here',
      "searchControlHeight": '100px',
      "searchQueryInputHandler": _vm.updateSearchQuery
    }
  })], 1)])], 1)], 1)]), _c('section', {
    staticClass: "my-4"
  }, [_c('VideoListItems', {
    attrs: {
      "videoInfoList": _vm.videoInfoList,
      "videoSearchQuery": _vm.videoSearchQuery,
      "scrollToElementId": 'videos-display-section',
      "searchByVideoType": true
    }
  })], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }